var AuthEndpoints;
(function (AuthEndpoints) {
    AuthEndpoints["GetAccessToken"] = "/oauth/token";
})(AuthEndpoints || (AuthEndpoints = {}));
var TokenGrantType;
(function (TokenGrantType) {
    TokenGrantType["Password"] = "password";
    TokenGrantType["Mfa"] = "mfa";
    TokenGrantType["Partner"] = "partner";
    TokenGrantType["RefreshToken"] = "refresh_token";
})(TokenGrantType || (TokenGrantType = {}));
var AccessTokenError;
(function (AccessTokenError) {
    AccessTokenError["InvalidGrant"] = "invalid_grant";
    AccessTokenError["MfaRequired"] = "mfa_required";
    AccessTokenError["UserInactive"] = "user_inactive";
})(AccessTokenError || (AccessTokenError = {}));
export { AccessTokenError, AuthEndpoints, TokenGrantType, };
